var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 17,
    viewBox: "0 0 30 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0013 3.40027C19.0795 3.40027 18.3349 2.64052 18.3349 1.70013C18.3349 0.759747 19.0795 0 20.0013 0H28.3336C29.2553 0 30 0.759747 30 1.70013V10.2008C30 11.1412 29.2553 11.9009 28.3336 11.9009C27.4118 11.9009 26.6671 11.1412 26.6671 10.2008V5.80702L17.8453 14.8018C17.1944 15.4659 16.1372 15.4659 15.4863 14.8018L10.0026 9.20728L2.84729 16.5019C2.19633 17.166 1.13917 17.166 0.488218 16.5019C-0.162739 15.8378 -0.162739 14.7593 0.488218 14.0952L8.82047 5.5945C9.47142 4.93039 10.5286 4.93039 11.1795 5.5945L16.6684 11.1943L24.308 3.40027H20.0013Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.f63290bb3db65b88b7715258ea04ca3b.svg";
export { ForwardRef as ReactComponent };